/* @flow */
import React from 'react';
import Modal from 'components/Modal.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Group from 'entities/Group';
import DialogContent from 'components/DialogContent.jsx';
import SmsInstruction from 'users/components/SmsInstruction.jsx';

import './styles/JoinDeviceBlockModal.scss';

const JoinDeviceBlockModal = React.createClass({
  propTypes: {
    group: React.PropTypes.instanceOf(Group).isRequired,
  },

  render() {
    return (
      <Modal>
        <DialogContent
          title="We cannot send you a code"
          subtext="Sign up via text below"
          {...this.props}>
          <BoxBody divided>
            <SmsInstruction
              group={this.props.group}
            />
          </BoxBody>
        </DialogContent>
      </Modal>
    );
  },
});

export default JoinDeviceBlockModal;



// WEBPACK FOOTER //
// ./src/join/components/JoinDeviceBlockModal.jsx